<template>
    <div>
		<div class="bg-grey-lighter w-full h-screen font-sans">
			<div class="container mx-auto h-full flex justify-center items-center">
				<div class="w-1/3">
					<div>
						<h1 class="font-light mb-3 text-center">UtskriftsAppen</h1>
						<h3 class="font-light mb-6 text-center">Logga in</h3>
						<div class="border-green p-8 border-t-4 bg-white mb-6 rounded-lg shadow-lg">
							<form autocomplete="off" @submit.prevent="login">
								<div class="mb-4">
									<label class="font-bold text-grey-darker block mb-2">E-post</label>
									<input type="email" class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-green-light" placeholder="Din e-post" v-model="email" required>
								</div>

								<div class="mb-4">
									<label class="font-bold text-grey-darker block mb-2">Lösenord</label>
									<input type="password" class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-green-light" placeholder="Ditt lösenord" v-model="password" required>
								</div>

								<div class="mb-4" v-if="error">
									<p class="text-red">
										Inloggningsuppgifterna stämde inte
									</p>
								</div>

								<div class="flex items-center justify-between">
									<button type="submit" class="bg-green mx-auto hover:bg-green-light text-white font-bold py-2 px-4 rounded mt-4">
										Logga in
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
	data(){
		return {
			email: null,
			password: null,
			error: false,
			errorMessage: ''
		}
	},
	
	created() {
		if(this.isAuthenticated) {
			this.$router.push({name: 'PrintLayout'})
		}
	},

	computed: {
		...mapGetters({
			isAuthenticated:	'auth/isAuthenticated',
			userName:			'auth/userName',
			user:				'auth/user',
		}),
	},

	methods: {
		login() {
			this.$store.dispatch("auth/AUTH_REQUEST", {
				email: this.email,
				password: this.password,
			}).then(response => {
				if(this.$route.path !== '/') {
					this.$router.push('/')
				}
			}).catch(error => {
				this.error = true
			})
		},
	}
}  
</script>